module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "div_autre",
    attrs: {
      "epub:type": "preamble"
    }
  }, [_c('div', {
    staticClass: "pre",
    attrs: {
      "id": "pre-001"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_1",
      "title": "1"
    }
  }, [_c('h1', {
    staticClass: "pre_tit",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_vm._v("Author’s Note")])]), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('span', {
    staticClass: "mev1"
  }, [_vm._v("I "), _c('span', {
    staticClass: "small"
  }, [_vm._v("AM FINISHING THIS BOOK")])]), _vm._v(" in early Eastertide 2020 and sending it out to an uncertain world. A pandemic has spread around the globe, death tolls are mounting, and we in the United States have largely been under stay-at-home orders. I have chosen not to specifically address the pandemic in these pages. When I wrote this manuscript, Covid-19 did not exist. By the time this book is released, any reader will likely have far more insight into the reality of Covid-19 and its effects on the world than I could give here. What is needed now is the slow work of wisdom, and I am too near the outset of this tragedy to offer that in any detail.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("But though I do not know what lies ahead, I know that whatever awaits us in this particular catastrophe, it will not be the last. We will face other natural disasters and global calamities. And there will be devastating yet more commonplace suffering that each reader will bring to these pages: personal stories of pain, vulnerability, anxiety, and loss that will continue long after the current crisis ends.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("So I send this book out with a prayer that it will bear light and truth, and do the work it’s been given to do."), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_2",
      "title": "2"
    }
  })])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30d0e461","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pre2.vue
// module id = 69
// module chunks = 0